'use strict';

namespace Attractions {
    type TripState = Core.Trip.TripState;
    type TripService = Core.TripService;
    class Attractions {

        attractions: any = {
            selected: [],
            occupancy: {}
        };

        attractionsAvailabilityBusy: boolean = true;
        getImageUrl: any;
        attractionQuotes: any;
        attractionsTotal: any;
        attractionsDescription: any;
        cheapestAttraction: any;

        toggleResults: any;
        showResults: boolean;
        viewInformation: any;
        viewResults: any;
        informationPath: string;
        state: any;
        viewWhatsIncluded: any;
        destination: string;

        isHotelJourney: boolean;
        hotel: any;
        constructor(
            private $routeParams,
            private $scope,
            private attractionDetailsService,
            private basketService,
            private basketStore,
            private dateUtil,
            private tripService: TripService,
            private broker: Core.Broker
            ) {

            var at = this;

            tripService.getTrip($routeParams.tripId).then(function (trip: TripState) {
                var basketId = trip.BasketId,
                    tripId = trip.TripId,
                    attractionSearchId = trip.AttractionRequest ? trip.AttractionRequest.AvailabilitySearchId : null;
                at.destination = trip.HotelsRequest && trip.HotelsRequest.Destination ?
                                 trip.HotelsRequest.Destination['Title'] : '';
                basketStore.attraction(basketId).then(function (results) {
                    var occupancyMap = {},
                        // Extras attractions format is one product entry with nested data for multiples
                        products = results && results[0];

                    if (products) {
                        at.attractions = {
                            selected: angular.copy(products.Details.AttractionIds),
                            occupancy: angular.copy(products.Details.AttractionRequests)
                        };
                    }


                    if (TRPCONFIG.Domain.AttractionsExtraEnabled || TRPCONFIG.Domain.AttractionsExtraMobileEnabled) {
                        basketStore.flight(basketId).then(function (flight) {
                            var flightDate = _.get(flight ,'Details.Itinerary.DepartureDate');
                            var dateDiff = dateUtil.dayDiff(flightDate, new Date());
                            if (dateDiff >= TRPCONFIG.MinDaysBeforeDeparture || at.isHotelJourney) {


                                basketService.getAttractionQuotes(attractionSearchId, basketId, tripId)
                                    .then(function (attractionQuotes) {
                                    at.attractionQuotes = attractionQuotes;
                                    at.cheapestAttraction = attractionQuotes[0];
                                    at.attractionsAvailabilityBusy = false;

                                    at.cheapestAttraction = getCheapest(at.attractionQuotes);

                                    function getCheapest(quotes) {
                                        const hasAdult = _.filter(quotes, (a: any) => {
                                            return a.Prices[0].Price > 0;
                                        });
                                        return _.minBy(hasAdult, (a: any) => {
                                            return a.Prices[0].Price;
                                        });
                                    }

                                    _updateSubtitle();
                                    var stopAttractionWatch = $scope.$watch('at.attractions',
                                        _attractionsWatch, true);

                                    angular.forEach(attractionQuotes, function (a) {
                                        occupancyMap[a.AttractionId] = at.attractions.occupancy[a.AttractionId] || {
                                            Adult: a.Prices[0].Count,
                                            Child: a.Prices[1].Count,
                                            Infant: a.Prices[2].Count
                                        };

                                    });
                                    // angular copy throwing digest loops in ie9, ie10
                                    at.attractions.occupancy = $.extend(true, {}, occupancyMap);

                                    function _attractionsWatch(val, oldval) {
                                        if (val == null || angular.equals(val, oldval) || !val.selected) {
                                            return;
                                        }
                                        if (val.selected.length > 0 && _validateAttractionOccupancy(val, oldval)) {
                                            tripService.getTrip(tripId).then(t => {
                                                attractionSearchId = t.AttractionRequest.AvailabilitySearchId;
                                                basketStore.putAttractionExtras(attractionSearchId, val, basketId)
                                                    .then(() => basketService.updateBasket())
                                                    .then(() => basketStore.attractionCost(basketId))
                                                    .then(cost => {
                                                        at.attractionsTotal = cost;
                                                        _updateSubtitle();
                                                    });
                                            });
                                        } else {
                                            basketStore.removeAttraction(basketId).then(basketService.updateBasket);
                                            at.attractionsTotal = 0;
                                            _updateSubtitle();
                                        }
                                    }

                                    function _validateAttractionOccupancy(val, oldval) {
                                        var selectedOriginal = angular.copy(val);
                                        var valid = false;
                                        var occupacyChange = false;
                                        angular.forEach(selectedOriginal.selected, function (attractionId, index) {
                                            var attrOcc = val.occupancy[attractionId];
                                            occupacyChange = _.some(attrOcc,
                                                (occ:any, type:any) => type !== 'Infant' && occ);
                                            if (occupacyChange) {
                                                valid = true;
                                            } else {
                                                if (val.selected.length <= oldval.selected.length) {
                                                    val.selected.splice(index, 1);
                                                }
                                                stopAttractionWatch();
                                                var attrOccu = occupancyMap[attractionId];
                                                val.occupancy[attractionId] = angular.copy(attrOccu);
                                                stopAttractionWatch = $scope.$watch('at.attractions',
                                                    _attractionsWatch, true);
                                            }
                                        });
                                        return valid;
                                    }

                                });

                                basketStore.attractionCost(basketId).then(function (cost) {
                                    at.attractionsTotal = cost;
                                });

                            } else {
                                at.attractionsAvailabilityBusy = false;
                            }
                        });
                    }


                }).then(null, basketService.restartHolidayWorkflow);

                function _updateSubtitle() {
                    let subTitle = '';
                    if (at.attractionQuotes && at.attractions.selected.length) {
                        angular.forEach(at.attractions.selected, id => {
                            let quote = _.find(at.attractionQuotes, (a:any) => id === a.AttractionId);
                            if (quote) {
                                subTitle += quote.ShortTitle + '<br>';
                            }
                        });
                    }
                    at.attractionsDescription = subTitle;
                }

            }, basketService.bookingAlreadyDone(`attractions: '${$routeParams.tripId}'`));

            at.getImageUrl = attractionDetailsService.getImageUrl;

            at.toggleResults = function(e) {
                e.preventDefault();
                at.showResults = !at.showResults;
                at.state.showInformation = false;
            };

            at.state = {
                showInformation: false,
                informationRequested: false,
                informationLoaded: false
            };

            at.viewInformation = function(e, id) {
                e.preventDefault();
                at.informationPath = 'partials/holidays/attractionmoreinformation/' + id;
                at.state.showInformation = true;
                broker.publish('attractionsInformationRequested');
            };

            at.viewWhatsIncluded = function(e, id) {
                e.preventDefault();
                at.informationPath = `partials/holidays/attractionwhatsincluded/${id}`;
                at.state.showInformation = true;
                broker.publish('attractionsInformationRequested');
            };

            at.$scope.$on('$includeContentRequested', function(args) {
                at.state.informationRequested = true;
                at.state.informationLoaded = false;

            });

            at.$scope.$on('$includeContentLoaded', function(args) {
                at.state.informationLoaded = true;
            });

            at.viewResults = function(e) {
                e.preventDefault();
                at.state.showInformation = false;
            };
        }
    }

    angular
        .module('attractions')
        .controller('Attractions', Attractions);

}
